import type { SupportedLanguage } from './index'

/**
 * Localized routes for Pierre Costruzioni.
 * Each key maps to a route name, with translations for Italian and English.
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
  },
  services: {
    it: 'servizi',
    en: 'services',
  },
  projects: {
    it: 'progetti',
    en: 'projects',
  },
  contacts: {
    it: 'contatti',
    en: 'contacts',
  },
  privacy: {
    it: 'privacy',
    en: 'privacy',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
